import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  disclaimer: {
    id: 'react-components.OKw4a6',
    defaultMessage: 'Your feedback will be shared with the Appsemble Team using Sentry',
  },
  submitError: {
    id: 'react-components.9i2X0U',
    defaultMessage: 'There was a problem submitting your feedback',
  },
  submitSuccess: {
    id: 'react-components.llujbI',
    defaultMessage: 'Your feedback has been submitted successfully. Thank you!',
  },
  nameLabel: {
    id: 'react-components.HAlOn1',
    defaultMessage: 'Name',
  },
  nameHelp: {
    id: 'react-components.+MEKje',
    defaultMessage: 'Your name will be used to personalize communication',
  },
  emailLabel: {
    id: 'react-components.sy+pv5',
    defaultMessage: 'Email',
  },
  emailHelp: {
    id: 'react-components.q+8ot1',
    defaultMessage: 'We may use your email address to contact you about this issue',
  },
  commentsLabel: {
    id: 'react-components.wCgTu5',
    defaultMessage: 'Comments',
  },
  commentsHelp: {
    id: 'react-components.OOCcE/',
    defaultMessage: 'Please help us by describing what went wrong',
  },
  submit: {
    id: 'react-components.lXIQ7a',
    defaultMessage: 'Submit error report',
  },
  emailInvalid: {
    id: 'react-components.jv0FOj',
    defaultMessage: 'This must be a valid email address',
  },
  emailRequired: {
    id: 'react-components.KssJcX',
    defaultMessage: 'An email address is required',
  },
});
